const amountOfNotificationsOnPage = 50;

export default amountOfNotificationsOnPage;
